import React from 'react'
import Header from '../../components/layout/header/Header'
import Footer from '../../components/layout/footer/Footer'

const MainLayout = ({ children }) => {
    return (
        <div>
            <Header />
            {children}
            <Footer />
        </div>
    )
}

export default MainLayout
